module.exports = __webpack_public_path__ + "media/images/tailwind/linkedin-f5b908d17236ed9607c9c3bf2d06e081.png";